import { ImageViewerPage } from '@components/enrollments/courses/course_contents/image_viewer/ImageViewerPage'
import { CourseContentsProvider } from '@contexts/CourseContentsContext'
import { CourseProvider } from '@contexts/CourseContext'
import { EnrollmentProvider } from '@contexts/EnrollmentContext'
import { ModulesProvider } from '@contexts/ModulesContext'
import { AppLayout } from '@layouts/AppLayout'

export default function CourseContents() {
  return (
    <CourseContentsProvider>
      <CourseProvider>
        <EnrollmentProvider>
          <CourseContentsProvider>
            <ModulesProvider>
              <AppLayout
                backRoute={{
                  label: 'Voltar',
                }}
                hasFooter={false}
                hasPaddingBottom={false}
              >
                <ImageViewerPage />
              </AppLayout>
            </ModulesProvider>
          </CourseContentsProvider>
        </EnrollmentProvider>
      </CourseProvider>
    </CourseContentsProvider>
  )
}
